import { combineReducers } from "redux"
import event from "./event";
import watchKey from "./watchKey";
import page from "./page";
import registered from "./registered";
import popup from "./popup";

export default combineReducers({
	event,
	watchKey,
	page,
	registered,
	popup,
});
